<template>
    <div class="sticky top-0 z-10 bg-gray-900 border-b border-gray-700">
        <div class="relative px-4 mx-auto max-w-7xl sm:px-6">
            <div class="flex justify-between items-top md:space-x-0 lg:space-x-10">
                <div class="flex">
                    <!-- Product Name -->
                    <div class="py-0 mt-1">
                        <a
                            class="flex items-center py-2 pr-5 text-white rounded"
                            href="#"
                        >
                            <span class="text-xl font-medium">{{ productName }}</span>
                        </a>
                    </div>

                    <!-- Desktop Menu -->
                    <nav class="hidden gap-2 text-sm font-normal text-gray-300 md:flex">
                        <div
                            v-for="item in menu"
                            :key="item.name"
                            class="py-2"
                        >
                            <BaseButton
                                v-if="!item.button"
                                :href="item.href"
                                :target="item.target"
                                :to="item.routerLink"
                                :variant="item.variant"
                            >
                                <span>{{ item.name }}</span>
                                <span
                                    v-if="$route.name == productName?.concat(' ', item.name) || ($route.path.includes(item.routerLink) && !item.default)"
                                    class="absolute left-0 h-0.5 -bottom-2 w-full overflow-hidden"
                                >
                                    <span class="absolute top-0 left-0 w-full h-1 bg-purple-400 rounded-full" />
                                </span>
                                <OpenInNewIcon
                                    v-if="item.target == '_blank'"
                                    :size="'1.2em'"
                                    class="inline-block ml-1 align-middle transform -translate-y-px"
                                />
                            </BaseButton>
                        </div>
                    </nav>
                </div>
                <!-- Button Get Started -->
                <div
                    v-for="item in menu"
                    :key="item.name"
                    class="hidden py-2 text-sm font-normal text-gray-300 md:flex md:items-center"
                >
                    <span
                        v-if="item.button"
                        class="px-4"
                    >
                        <slot name="trialMessage" />
                    </span>
                    <BaseButton
                        v-if="item.button"
                        :href="item.href"
                        :target="item.target"
                        :to="item.routerLink"
                        :variant="item.variant"
                    >
                        <span>{{ item.name }}</span>
                    </BaseButton>
                </div>

                <!-- Open Mobile Menu -->
                <div class="inline-flex gap-4 my-2 -mr-2 md:hidden">
                    <base-button
                        v-if="callToAction"
                        :href="callToAction.href"
                        :to="callToAction.routerLink"
                        class="text-sm"
                    >
                        {{ callToAction.name }}
                    </base-button>
                    <button
                        class="inline-flex items-center justify-center p-2 text-gray-400 bg-gray-900 rounded-md hover:text-gray-500 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                        @click="mobileMenuOpen = !mobileMenuOpen"
                    >
                        <span class="sr-only">Open menu</span>
                        <ChevronDownIcon
                            :class="mobileMenuOpen ? 'rotate-180' : ''"
                            aria-hidden="true"
                            class="w-6 h-6"
                        />
                    </button>
                </div>
            </div>

            <!-- Mobile Menu -->
            <transition
                enter-active-class="duration-200 ease-out"
                enter-from-class="scale-95 opacity-0"
                enter-to-class="scale-100 opacity-100"
                leave-active-class="duration-100 ease-in"
                leave-from-class="scale-100 opacity-100"
                leave-to-class="scale-95 opacity-0"
            >
                <div
                    v-if="mobileMenuOpen"
                    class="absolute inset-x-0 p-2 pb-4 transition origin-top transform bg-gray-900 border-b border-gray-600 top-14 md:hidden"
                    focus
                >
                    <div class="flex flex-col gap-4">
                        <div
                            v-for="item in menu"
                            :key="item.name"
                            :class="$route.name == productName?.concat(' ', item.name) || ($route.path.includes(item.routerLink) && !item.default) ? 'border-l-2 pl-2 border-purple-500' : ''"
                        >
                            <BaseButton
                                v-if="item != callToAction"
                                :variant="item.variant"
                                @click="onMobileLinkClicked(item.routerLink, item.href)"
                            >
                                {{ item.name }}
                                <OpenInNewIcon
                                    v-if="item.target == '_blank'"
                                    :size="'1.2em'"
                                    class="inline-block ml-1 align-middle transform -translate-y-px"
                                />
                            </BaseButton>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ChevronDownIcon } from "@heroicons/vue/outline";
import BaseButton from "../../common/components/BaseButton.vue";
import { computed, defineProps, ref } from "vue";
import { useRouter } from "vue-router";
import OpenInNewIcon from "vue-material-design-icons/OpenInNew.vue";

const router = useRouter();
const mobileMenuOpen = ref(false);

const props = defineProps({
    menu: {
        type: Object,
        default: null
    },
    productName: {
        type: String,
        default: ""
    }
});

const callToAction = computed(() =>
{
    const filtered = props.menu.filter(e => e.variant === "default");
    return filtered.length > 0 ? filtered[0] : null;
});

function onMobileLinkClicked (to, href)
{
    mobileMenuOpen.value = false;
    if (to)

        router.push(to);

    else

        window.location.assign(href);
}

</script>
